export default __webpack_public_path__ + "static/media/course1_R.ea2225c2.gif";